function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/navigation/ic-expand-more");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M15.8842316,8.99923077 L12,12.875 L8.11576839,8.99923077 C7.72585884,8.61017069 7.09448505,8.61051495 6.705,9 L6.705,9 C6.31563925,9.38936075 6.31563925,10.0206393 6.705,10.41 L11.2928932,14.9978932 C11.6834175,15.3884175 12.3165825,15.3884175 12.7071068,14.9978932 L17.295,10.41 C17.6843607,10.0206393 17.6843607,9.38936075 17.295,9 L17.295,9 C16.905515,8.61051495 16.2741412,8.61017069 15.8842316,8.99923077 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "icon/navigation/ic-expand-more",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "icon/navigation/expand_more_24px",
  fill: "#333340",
  xlinkHref: "#path-1"
}));

var SvgIcExpandMore = function SvgIcExpandMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcExpandMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-expand-more.72e7309a.svg";
export { ForwardRef as ReactComponent };